/** Bar / pub drink & bar-stock categories (Tanzania). */

export const BAR_STOCK_CATEGORIES = [
  'Beer (bottle / can)',
  'Beer (crate / box)',
  'Spirits & liquor',
  'Wine',
  'Soft drinks & sodas',
  'Juice & energy drinks',
  'Water',
  'Mixers & tonics',
  'Snacks & bites',
  'Bar supplies (ice, cups, straws)',
  'Other',
];

/** @returns {{ value: string, label: string }[]} */
export function barCategorySelectOptions() {
  return [{ value: '', label: 'Select category…' }, ...BAR_STOCK_CATEGORIES.map((c) => ({ value: c, label: c }))];
}

/** @param {{ category?: string }[]} products */
export function mergedBarCategories(products) {
  const fromDb = Array.from(
    new Set((products || []).map((p) => (p.category || '').trim()).filter(Boolean))
  );
  const catalog = new Set(BAR_STOCK_CATEGORIES);
  const extras = fromDb.filter((c) => !catalog.has(c));
  return [...BAR_STOCK_CATEGORIES, ...extras].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
}
